<template>
  <div>
    <HeaderAfterLogin v-if="isAuthenticated" />
    <HeaderBeforeLogin v-else />
  </div>
</template>

<script>
import HeaderAfterLogin from '../header-after-login'
import HeaderBeforeLogin from '../header-before-login'

export default {
  name: 'AppHeader',

  components: {
    HeaderAfterLogin,
    HeaderBeforeLogin
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>

<style lang="scss" scoped>
.testimonials .header_fix {
  background: #000;
}
</style>